import React from 'react';

type PropsType = React.SVGProps<SVGSVGElement>;

export const StreeningIcon: React.FC<PropsType> = props => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.99951 1.16797C13.3256 1.16797 16.8333 4.67489 16.8335 9.00098C16.8335 13.3272 13.3257 16.835 8.99951 16.835C4.67343 16.8348 1.1665 13.3271 1.1665 9.00098C1.16668 4.675 4.67354 1.16815 8.99951 1.16797ZM11.8335 9.83496C11.8333 10.9393 10.9378 11.8348 9.8335 11.835H9.3335V12.335L9.33447 15.6162V16.1826L9.896 16.1123C13.1379 15.7076 15.7061 13.1394 16.1108 9.89746L16.1812 9.33594H15.6147L12.3335 9.33496H11.8335V9.83496ZM8.99951 1.83496C5.34461 1.83512 2.32905 4.57081 1.88818 8.10645L1.81885 8.66797H6.1665V8.16797C6.1665 7.98398 6.31556 7.83514 6.49951 7.83496H11.4995C11.6836 7.83496 11.8335 7.98386 11.8335 8.16797V8.66797H16.1812L16.1108 8.10645C15.6699 4.57072 12.6545 1.83496 8.99951 1.83496ZM8.6665 11.835H8.1665C7.06204 11.835 6.16668 10.9394 6.1665 9.83496V9.33496H5.6665L2.38428 9.33594H1.81885L1.88916 9.89746C2.29392 13.1396 4.86264 15.708 8.10498 16.1123L8.6665 16.1826V11.835Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
);
